import { RecommendedCity } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory<EntityType<RecommendedCity>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const detectMarketReducer = createReducer<State, Actions>(initialState, {
  [actions.detectMarket.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.detectMarket.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.detectMarket.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.detectMarket.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default detectMarketReducer;
